export default function formatCijferToLetter (value) {
  if (value === undefined || value == null || value === 0) return ''
  else if (Number(value) >= 85) return 'zg'
  else if (Number(value) >= 75) return 'g'
  else if (Number(value) >= 65) return 'rv'
  else if (Number(value) > 54) return 'v'
  else return 'o'
}
